import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
      <ng-progress [positionUsing]="'marginLeft'" [minimum]="0.15" [maximum]="1"
                [speed]="200" [showSpinner]="false" [direction]="'leftToRightIncreased'"
                [color]="'#29d'" [trickleSpeed]="250" [thick]="true" [ease]="'linear'"></ng-progress>
    <router-outlet name="header"></router-outlet>
    <router-outlet></router-outlet>
    <router-outlet name="footer"></router-outlet>
    <simple-notifications [options]="notificationOptions"></simple-notifications>
  `,
  styles: [`
    :host {
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;
    }
  `]
})
export class AppComponent {
  notificationOptions = {
    timeOut: 3000,
    maxStack: 4,
    theClass: 'toast'
  };
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts